import { Calendar, Flashbar } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { format, parse } from 'date-fns';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';

const pageSize = 20;

export const AdminCasinoStatementsMonthlyPage = () => {
  //const storeAdmin = useStoreAdmin();

  const { menu, parameters, data } = useGlobalState();
  const { navigate } = useRouter();


  const [movements, setMovements] = useState<any[]>([]);
  const [total, setTotal] = useState(0);


  useEffect(() => {
    handleRefreshMovements();
  }, [parameters?.month, parameters?.year]); //parameters.startDate, parameters.endDate, 


  const stats = movements.reduce((acc, m) => {
    return {
      total: acc.total + (Number(m.ammount * -1) || 0), // Ensure it's treated as a number
      transactions: acc.transactions + 1
    };
  }, { total: 0, transactions: 0 });
  const handleRefreshMovements = async () => {
    //if (parameters.startDate && parameters.endDate) { 
    if (parameters.month && parameters.year) {

      try {
        setLoading(true)
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/movements/casino/list',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify(
            {
              limit: 1000,
              ammount: -1,
              month: parameters.month,
              year: parameters.year,
            }
          ),
          //mode: 'no-cors'  // Bypasses CORS but limits the response
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const dataWeb = await response.json();
        if (dataWeb.code == 0) {
          setMovements(dataWeb.movements);
        } else {
          addNotification(dataWeb.status, 'error', setData);
        }
      } catch (error: any) {
        addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
      } finally { setLoading(false) }

    };
  }
  return (
    <CustomAppLayout
      toolsHide

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <SpaceBetween direction="vertical" size="xs">

            <Header
              description={<>Total y número de transacciones por periodo</>}
              actions={
                <SpaceBetween direction="horizontal" size="xs">

                  <Favorites />
                </SpaceBetween>
              }
            >
              Consolidado mensual
            </Header>
            <SpaceBetween direction="horizontal" size="xs">
              <div style={{ width: 250 }}>
                <Calendar
                  onChange={({ detail }) => {
                    setParameters({
                      ...parameters, month: detail.value.replace("/", "-").split("-")[1], year: detail.value.replace("/", "-").split("-")[0],
                      period: detail.value.replace("/", "-")

                    });
                  }}
                  isDateEnabled={date => date < new Date()}
                  value={parameters.period}
                  locale="es-CL"
                  granularity="month"
                /></div>
              <div style={{ width: 250 }}>
                {!!stats.total && stats.total > 0 && (
                  <Flashbar items=
                    {[
                      {
                        type: "info",
                        action: `${stats.transactions} ${stats.transactions > 1 ? "transacciones" : "transacción"}`,
                        header: format(parse(parameters.period + "-01", "yyyy-MM-dd", new Date()), "MMMM yyyy"),
                        content:
                          <h1>{formatCurrency(stats.total, "CLP")}</h1>
                        ,
                        id: "message_1"
                      }]} />
                )}
              </div>
            </SpaceBetween>
          </SpaceBetween>
        </>
      }
    />
  )
};
